// Check if Mapbox should be used
function useMapbox() {
  // Check data attribute first (set by view template)
  const mapContainer = document.getElementById('pages-job-announcements-new-map');
  if (mapContainer && mapContainer.dataset.useMapbox === 'true') {
    return true;
  }
  // Fallback to global config (if set via window)
  return window.mapsConfig?.provider === 'mapbox' || false;
}

// Get the appropriate manager
function getMapsManager() {
  return useMapbox() ? window.mapboxManager : window.googleMapsManager;
}

// Get the API key/access token
function getMapsCredential(container) {
  return useMapbox() 
    ? container.dataset.accessToken 
    : container.dataset.apiKey;
}

document.addEventListener('turbo:load', function(e) {
  const mapContainer = document.getElementById('pages-job-announcements-new-map');
  if (!mapContainer) return;

  if (useMapbox()) {
    pgJobAnnouncementsNewMapRadiusLoadMapbox();
  } else {
    pgJobAnnouncementsNewMapRadiusLoadGoogleMapsAPI();
  }
});

/* --------------------------------------------------
                Create Map Radius (Google Maps)
-------------------------------------------------- */
pgJobAnnouncementsNewMapRadius = function(){
  const googleMaps = document.getElementById('pages-job-announcements-new-map');
  if (!googleMaps) return;

  // Get job location
  const jobLat = parseFloat(googleMaps.dataset.lat);
  const jobLng = parseFloat(googleMaps.dataset.lng);

  // Get radius slider
  const radiusSlider = document.getElementById('pages-job-announcements-new-radius');
  const radiusValue = document.getElementById('pages-job-announcements-new-radius-value');
  const radiusInput = document.querySelector('input[name="job_announcement[radius]"]');

  // Set initial radius value
  if (radiusInput) {
    radiusInput.value = radiusSlider ? radiusSlider.value : 10;
  }

  // Create map
  const map = new google.maps.Map(googleMaps, {
    zoom: 10,
    center: { lat: jobLat, lng: jobLng },
    mapTypeControl: false,
    streetViewControl: false,
    zoomControl: true,
    zoomControlOptions: {
      position: google.maps.ControlPosition.RIGHT_CENTER
    },
    mapId: 'job_announcement_map'
  });

  // Add radius circle to map
  const radiusCircle = new google.maps.Circle({
    strokeColor: '#000000',
    strokeOpacity: 0.8,
    strokeWeight: 2,
    fillColor: '#000000',
    fillOpacity: 0.35,
    map: map,
    center: { lat: jobLat, lng: jobLng },
    radius: radiusInput ? radiusInput.value * 1609.34 : 16093.4,
    editable: false
  });

  // Add event listener to radius slider
  if (radiusSlider && radiusInput) {
    radiusSlider.addEventListener('input', function() {
      const miles = parseInt(this.value);
      const meters = miles * 1609.34;
      
      radiusCircle.setRadius(meters);
      if (radiusValue) {
        radiusValue.textContent = miles;
      }
      radiusInput.value = miles;
    });

    // Set initial circle radius based on slider value
    const initialMiles = parseInt(radiusSlider.value);
    radiusCircle.setRadius(initialMiles * 1609.34);
    if (radiusValue) {
      radiusValue.textContent = initialMiles;
    }
  }

  // Add marker to map
  const pinElement = new google.maps.marker.PinElement({
    scale: 1,
    background: '#000000',
    borderColor: '#FFFFFF',
    glyphColor: '#FFFFFF',
    glyph: '●'
  });

  new google.maps.marker.AdvancedMarkerElement({
    map: map,
    position: { lat: jobLat, lng: jobLng },
    title: 'Job Location',
    content: pinElement.element
  });
}

/* --------------------------------------------------
                Load Map Radius Google Maps API
-------------------------------------------------- */
pgJobAnnouncementsNewMapRadiusLoadGoogleMapsAPI = function() {
  if (typeof google !== 'undefined') {
    pgJobAnnouncementsNewMapRadius();
    return;
  }
  
  // Get map container
  const mapContainer = document.getElementById('pages-job-announcements-new-map');
  if (!mapContainer) return;
  
  // Get API key
  const apiKey = mapContainer.dataset.apiKey;
  const script = document.createElement('script');

  // Load Google Maps API
  script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&callback=initMap&libraries=marker&v=beta`;
  script.async = true;
  script.defer = true;

  // Initialize map
  window.initMap = function() {
    pgJobAnnouncementsNewMapRadius();
  };

  // Append script to head
  document.head.appendChild(script);
}

/* --------------------------------------------------
                Create Map Radius (Mapbox)
-------------------------------------------------- */
async function pgJobAnnouncementsNewMapRadiusMapbox() {
  const mapContainer = document.getElementById('pages-job-announcements-new-map');
  if (!mapContainer) return;

  const manager = getMapsManager();
  const credential = getMapsCredential(mapContainer);

  // Get job location
  const jobLat = parseFloat(mapContainer.dataset.lat);
  const jobLng = parseFloat(mapContainer.dataset.lng);

  // Get radius slider
  const radiusSlider = document.getElementById('pages-job-announcements-new-radius');
  const radiusValue = document.getElementById('pages-job-announcements-new-radius-value');
  const radiusInput = document.querySelector('input[name="job_announcement[radius]"]');

  // Set initial radius value
  if (radiusInput) {
    radiusInput.value = radiusSlider ? radiusSlider.value : 10;
  }

  // Load Mapbox API
  await manager.loadAPI(credential);

  // Create map
  const mapOptions = {
    style: 'mapbox://styles/mapbox/streets-v12',
    center: [jobLng, jobLat], // [lng, lat] format
    zoom: 10
  };

  const map = manager.createMapWithCache(mapContainer, mapOptions, 'job-announcements-map');

  // Add navigation controls
  if (window.mapboxgl && typeof window.mapboxgl.NavigationControl !== 'undefined') {
    map.addControl(new window.mapboxgl.NavigationControl(), 'top-right');
  }

  // Wait for map to load
  map.on('load', () => {
    let radiusSourceId = 'radius-circle';
    let radiusFillLayerId = 'radius-circle-fill';
    let radiusStrokeLayerId = 'radius-circle-stroke';

    // Helper function to create circle GeoJSON
    function createCircleGeoJSON(center, radiusMiles) {
      const radiusMeters = radiusMiles * 1609.34;
      const earthRadius = 6378137; // Earth's radius in meters
      const latRad = center[1] * Math.PI / 180;
      const lngRad = center[0] * Math.PI / 180;
      const angularDistance = radiusMeters / earthRadius;

      const coordinates = [];
      for (let i = 0; i <= 64; i++) {
        const angle = (i * 360 / 64) * Math.PI / 180;
        const lat = Math.asin(
          Math.sin(latRad) * Math.cos(angularDistance) +
          Math.cos(latRad) * Math.sin(angularDistance) * Math.cos(angle)
        );
        const lng = lngRad + Math.atan2(
          Math.sin(angle) * Math.sin(angularDistance) * Math.cos(latRad),
          Math.cos(angularDistance) - Math.sin(latRad) * Math.sin(lat)
        );
        coordinates.push([lng * 180 / Math.PI, lat * 180 / Math.PI]);
      }
      coordinates.push(coordinates[0]); // Close the circle

      return {
        type: 'Feature',
        geometry: {
          type: 'Polygon',
          coordinates: [coordinates]
        }
      };
    }

    // Function to update circle
    function updateCircle(radiusMiles) {
      const center = [jobLng, jobLat];
      const circleGeoJSON = createCircleGeoJSON(center, radiusMiles);

      // Remove existing layers and source if they exist
      if (map.getLayer(radiusFillLayerId)) {
        map.removeLayer(radiusFillLayerId);
      }
      if (map.getLayer(radiusStrokeLayerId)) {
        map.removeLayer(radiusStrokeLayerId);
      }
      if (map.getSource(radiusSourceId)) {
        map.removeSource(radiusSourceId);
      }

      // Add source and layers
      map.addSource(radiusSourceId, {
        type: 'geojson',
        data: circleGeoJSON
      });

      // Fill layer
      map.addLayer({
        id: radiusFillLayerId,
        type: 'fill',
        source: radiusSourceId,
        paint: {
          'fill-color': '#000000',
          'fill-opacity': 0.35
        }
      });

      // Stroke layer
      map.addLayer({
        id: radiusStrokeLayerId,
        type: 'line',
        source: radiusSourceId,
        paint: {
          'line-color': '#000000',
          'line-width': 2,
          'line-opacity': 0.8
        }
      });
    }

    // Set initial circle
    const initialMiles = radiusInput ? parseInt(radiusInput.value) : 10;
    updateCircle(initialMiles);

    // Add event listener to radius slider
    if (radiusSlider && radiusInput) {
      radiusSlider.addEventListener('input', function() {
        const miles = parseInt(this.value);
        updateCircle(miles);
        if (radiusValue) {
          radiusValue.textContent = miles;
        }
        radiusInput.value = miles;
      });
    }

    // Add marker to map
    const el = document.createElement('div');
    el.className = 'mapbox-marker';
    el.style.width = '32px';
    el.style.height = '32px';
    el.style.cursor = 'pointer';
    
    const img = document.createElement('img');
    img.src = '/map-pin.png';
    img.style.width = '100%';
    img.style.height = '100%';
    img.style.display = 'block';
    img.alt = 'Job Location';
    el.appendChild(img);

    const marker = manager.createMarker({
      element: el,
      anchor: 'bottom'
    });

    marker.setLngLat([jobLng, jobLat]);
    marker.addTo(map);
  });
}

/* --------------------------------------------------
                Load Map Radius Mapbox API
-------------------------------------------------- */
async function pgJobAnnouncementsNewMapRadiusLoadMapbox() {
  try {
    await pgJobAnnouncementsNewMapRadiusMapbox();
  } catch (error) {
    console.error('Failed to load Mapbox map:', error);
    const mapContainer = document.getElementById('pages-job-announcements-new-map');
    if (mapContainer) {
      mapContainer.innerHTML = '<div class="flex items-center justify-center h-full text-gray-500">Failed to load map</div>';
    }
  }
}
